module.exports = __webpack_public_path__ + "slide2-environments-ie11.f964e848a83136a394e9ef616d82c4bd.hashedasset.svg";